<template>
  <v-card>
    <div class="pt-6">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
              depressed
              color="primary"
              v-on:click="back()"
            >
              返回
            </v-btn>
          </div>
          <div>
            <v-btn
              depressed
              color="primary"
              class="margin-right"
              @click="doImport"
              :disabled="!(detailInfo.status==1||detailInfo.status==2)"
              v-if="_hasButtonPermission('录入')"
            >
              录入
            </v-btn>
            <v-btn
              depressed
              color="primary"
              class="margin-right"
              @click="clickSubmit"
              :disabled="detailInfo.status!=2"
              v-if="_hasButtonPermission('提交')"
            >
              提交
            </v-btn>
            <v-btn
              depressed
              color="primary"
              class="margin-right"
              @click="clickAudit"
              :disabled="detailInfo.status!=3"
              v-if="_hasButtonPermission('审批')"
            >
              审批
            </v-btn>
            <v-btn
              depressed
              color="primary"
              @click="clickExport"
              v-if="_hasButtonPermission('导出')"
            >
              导出
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-10">
          <div class="scroll-wrapper">
            <v-simple-table
              fixed-header
              height="850px"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" rowspan="3" style="width: 100px; min-width: 100px;">
                      事项编号
                    </th>
                    <th class="text-left" rowspan="3" style="width: 100px; min-width: 100px;">
                      所属科目
                    </th>
                    <th class="text-left" rowspan="3" style="width: 180px; min-width: 180px;">
                      业务事项
                    </th>
                    <th class="text-left" rowspan="3" style="width: 100px; min-width: 100px;">
                      自维/外委
                    </th>
                    <th class="text-left" rowspan="3" style="width: 200px; min-width: 200px;">
                      维保内容
                    </th>
                    <th class="text-left" rowspan="3" style="width: 100px; min-width: 100px;">
                      标准次数
                    </th>
                    <th class="text-left" rowspan="3" style="width: 100px; min-width: 100px;">
                      周期
                    </th>
                    <th class="text-left" rowspan="3" style="width: 100px; min-width: 100px;">
                      是否涉及
                    </th>
                    <th class="text-center" style="width: 100px; min-width: 100px;">
                      合计
                    </th>
                    <th class="text-center" colspan="12" style="width: 800px; min-width: 800px;">
                      业务实施计划
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center">
                      {{detailInfo.effectAllNum}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect1}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect2}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect3}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect4}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect5}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect6}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect7}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect8}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect9}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect10}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect11}}
                    </th>
                    <th class="text-center">
                      {{detailInfo.effect12}}
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center">
                      
                    </th>
                    <th class="text-center">
                      1月
                    </th>
                    <th class="text-center">
                      2月
                    </th>
                    <th class="text-center">
                      3月
                    </th>
                    <th class="text-center">
                      4月
                    </th>
                    <th class="text-center">
                      5月
                    </th>
                    <th class="text-center">
                      6月
                    </th>
                    <th class="text-center">
                      7月
                    </th>
                    <th class="text-center">
                      8月
                    </th>
                    <th class="text-center">
                      9月
                    </th>
                    <th class="text-center">
                      10月
                    </th>
                    <th class="text-center">
                      11月
                    </th>
                    <th class="text-center">
                      12月
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in detailInfo.detailList" :key="item.matterId">
                    <td class="text-center">{{item.itemCode}}</td>
                    <td class="text-center" v-if="index==0||(index>0&&item.subjectName!=detailInfo.detailList[index-1].subjectName)" 
                :rowspan="_calcRowSpan(index,detailInfo.detailList,'subjectName')" >{{item.subjectName}}</td>
                    <td class="text-center">{{item.itemName}}</td>
                    <td class="text-center">{{item.type}}</td>
                    <td class="text-center">{{item.wbContent}}</td>
                    <td class="text-center">{{item.times}}</td>
                    <td class="text-center">{{item.cycle}}</td>
                    <td class="text-center">{{item.isInvolve}}</td>
                    <td class="text-center">{{item.effectAllNum}}</td>
                    <td class="text-center">{{item.effect1}}</td>
                    <td class="text-center">{{item.effect2}}</td>
                    <td class="text-center">{{item.effect3}}</td>
                    <td class="text-center">{{item.effect4}}</td>
                    <td class="text-center">{{item.effect5}}</td>
                    <td class="text-center">{{item.effect6}}</td>
                    <td class="text-center">{{item.effect7}}</td>
                    <td class="text-center">{{item.effect8}}</td>
                    <td class="text-center">{{item.effect9}}</td>
                    <td class="text-center">{{item.effect10}}</td>
                    <td class="text-center">{{item.effect11}}</td>
                    <td class="text-center">{{item.effect12}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-row>
      </v-card>
      <!--导入弹窗-->
      <v-dialog v-model="importDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
            >预算录入</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-file-input
                    truncate-length="15"
                    label="选择excel"
                    small-chips
                    dense
                    v-model="importFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleImport"> 确认 </v-btn>
            <v-btn color="primary" text @click="downloadTemplate">
              下载模板
            </v-btn>
            <v-btn text @click="hideImport"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--审批弹窗-->
      <v-dialog
        v-model="auditDialog"
        width="300"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            请审批
          </v-card-title>
          <v-card-text>
            <div class="padding-bottom padding-top">
              <v-btn
                depressed
                color="primary"
                class="margin-right"
                :disabled="btnDisabled"
                @click="auditApprove"
              >
                审批通过
              </v-btn>
              <v-btn
                depressed
                color="primary"
                :disabled="btnDisabled"
                @click="auditDismissal"
              >
                驳回
              </v-btn>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="auditDialog = false"
            >
              取消
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { default as ShopPlanApi } from "@/api/pd/plan/ShopPlanApi.js";
import downloadUtil from "@/util/downloadUtil.js";
export default {
  props: {
    id: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      detailInfo: {
        detailList: []
      },
      btnDisabled: false,
      importDialog: false,
      importFile: undefined,
      auditDialog: false
    };
  },
  mounted(){
    // 默认取1
	  this.getDataFromApi();
  },
  methods:{
    back(){
      this.$emit("back")
    },
    async getDataFromApi() {
      let me = this;
      let queryUserResp = await ShopPlanApi.detail({
        planId: me.id
      });
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取维保预算详情失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取维保预算详情情况失败(无会话数据)");
      }
      me.detailInfo = data.data;
    },
    async clickSubmit() {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认提交记录吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await ShopPlanApi.submit(me.id);
        if (res.data.code === 200) {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作失败",
          });
        }
      }
    },
    // 点击审批
    clickAudit(){
      this.auditDialog = true
    },
    // 审批通过
    async auditApprove(){
      let me = this;
      me.btnDisabled = true
      let res = await ShopPlanApi.approve(me.id);
      if (res.data.code === 200) {
        me.$dialog.info({
          text:'审批通过',
          title:'操作成功'
        })
        me.auditDialog = false
        me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
      me.btnDisabled = false
    },
    // 审批驳回
    async auditDismissal(){
      let me = this;
      me.btnDisabled = true
      let res = await ShopPlanApi.dismissal(me.id);
      if (res.data.code === 200) {
        me.$dialog.info({
          text:'驳回成功',
          title:'操作成功'
        })
        me.auditDialog = false
        me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
      me.btnDisabled = false
    },
    async clickExport() {
      let me = this;
      let res = await ShopPlanApi.exportData({
        planId: me.id
      });
      downloadUtil.downloadByBlob({ res: res.data, fileName: "事项预算导出数据.xlsx" });
    },
    doImport() {
      this.importDialog = true;
    },
    hideImport() {
      this.importDialog = false;
    },
    async handleImport() {
      let me = this;
      let file = me.importFile;
      if (!file || !file.size) {
        me.$dialog.error({
          text: "文件必传",
          title: "操作失败",
        });
        return;
      }
      let res = await ShopPlanApi.importData(file,me.id);
      console.log("导入结果", res);
      if (res.data.code === 200) {
        me.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg_detail,
          title: res.data.msg,
        });
      }
      me.hideImport();
      me.importFile = undefined;
    },
    async downloadTemplate() {
      let me = this;
      let res = await ShopPlanApi.importTemplate({
        planId: me.id
      });
      downloadUtil.downloadByBlob({ res: res.data, fileName: "事项录入导入模板.xlsx" });
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    _calcRowSpan(index,items,title){
      let name = items[index][title]
      let num = 0
      for(let i=index;i<items.length;i++){
        if(name!==items[i][title]){
          break
        }
        num++
      }
      return num
    }
  }
};
</script>
<style scoped>
.scroll-wrapper{
  overflow-y: auto;
}
th,td{
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.padding-bottom{
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top{
  padding-top: 30px;
}
.margin-right{
  margin-right: 12px;
}
</style>